import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ZoneService } from '../proxy/planning/controllers/zone.service';
import { RegionService } from '../proxy/planning/controllers/region.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { VendorService } from '@controlling/proxy/controlling/controllers';
import { MeasurementTypeService } from '@woodsupply/proxy/wood-supply/controllers/measurement-type.service';

import { CostCenterByLocation } from '../cost-center-by-location/cost-center-by-location';
FieldBuilder.setNamespace('Planning');

export const MILL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Mill.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('capacity', 'Entity.Mill.Capacity')
    .decimal(2,9)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .display('fantasyName')
    .keyField('id')
    .build(),
  FieldBuilder
    .checkbox('isEligibleForElectronicInvoice', 'Entity.Mill.IsEligibleForElectronicInvoice')
    .build(),
  FieldBuilder
    .checkbox('isDestinationWoodLog', 'Entity.Mill.IsDestinationWoodLog')
    .build(),
  FieldBuilder
    .checkbox('isTransferLogyard', 'Entity.Mill.IsTransferLogyard')
    .build(),
  FieldBuilder
    .checkbox('demandSaleContract', 'Entity.Mill.DemandSaleContract')
    .build(),
  FieldBuilder
    .text('remsoftName', 'Entity.Mill.RemsoftName')
    .maxLength(200)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('measurementTypeId', 'Entity.Mill.MeasurementType', MeasurementTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.Mill.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('regionId', 'Entity.Region', RegionService)
    .displayFromNested('region.name')
    .sortBy('region.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const MILL_CONFIG = {
  entityName: 'Mill',
  localizationKey: 'Planning::Entity.Mill',
  fields: MILL_FIELDS,
  permission: 'ControllingStructural.Mills',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'CostCenterByLocation',
      foreignKeyField: 'locationId',
      localizationKey: 'Planning::Entity.CostCenterByLocation',
      component: CostCenterByLocation,
    },
  ],
};
